var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsiteOnline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.78px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 107.91,
    cy: 95.32,
    r: 35.51
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 107.91,
    cy: 95.32,
    rx: 19.26,
    ry: 35.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.91,
    y1: 59.8,
    x2: 107.91,
    y2: 130.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 72.39,
    y1: 95.55,
    x2: 143.42,
    y2: 95.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.01,
    y1: 77.81,
    x2: 138.8,
    y2: 77.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.01,
    y1: 113.28,
    x2: 138.8,
    y2: 113.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.98,
    y: 44.79,
    width: 161.85,
    height: 99.6,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.55,171.65H21.26c-9.31,0-12.85-4.83-7.86-10.74l9.52-9.37c5-5.91,10-6.71,17.3-6.71H175.61c7.28,0,12.79.56,17.78,6.47l9,9.61C207.4,166.82,203.86,171.65,194.55,171.65Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteOnline);
export default __webpack_public_path__ + "static/media/WEBSITE_ONLINE.cb5d3f41346dd836fe7e0ec51d68b0c5.svg";
export { ForwardRef as ReactComponent };